class FilterGoogleMap {

    constructor (params) {
        // Init variables
	    this.$cache             = {};
	    this.$cache.main        = params.target;
        this.mapId              = document.getElementById('map');
        this.resultscontainer   = document.getElementById('results-retailers');
        this.inputlocal         = document.getElementById('localisation');
        this.inputerror         = document.getElementById('error');
        this.dir                = window.dir;
        this.retailers              = window.retailers;
        this.center             = { lat: 45.508888, lng: -73.561668 };
        this.markers            = [];
        this.closest            = [];
        this.checks             = [];
        this.infowindow         = new window.google.maps.InfoWindow( {pixelOffset : new window.google.maps.Size(0, -5)} );
        this.bounds;

        this.initCache();
        this.initEventsConst();
        this.registerEvents();

        this.initMap(this.retailers);
    }

    initCache() {
        this.$cache.btn         = this.$cache.main.find('#find');
        this.$cache.reset       = this.$cache.main.find('#reset');
        this.$cache.form        = this.$cache.main.find('#filter-map'); 
        this.$cache.drop        = this.$cache.main.find('h2.mb-dropdown');
    }

    initEventsConst() {
        this.getZipCodeEvent        = (e) => this.getZipCode(e);
        this.clickInputsEvent       = (e) => this.clickInputs(e);
        this.resetEvent             = (e) => this.reset(e);
        this.dropdownMobileEvent    = (e) => this.dropdownMobile(e);
    }

    registerEvents() {
        this.$cache.btn.on('click', this.getZipCodeEvent);
        this.$cache.reset.on('click', this.resetEvent);
        this.$cache.drop.on('click', this.dropdownMobileEvent);
    }

    // Initiation Google Map
    initMap(retailers) {
        this.map = new window.google.maps.Map(this.mapId, {
            center: this.center,
            zoom: 8,
            scrollwheel: true,
            streetViewControl: false,
            overviewMapControl: true,
            disableDefaultUI: false,
            disableDoubleClickZoom: true,
            mapTypeControl: false,
            styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#6D6D6D"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#E7E7E7"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#FFFFFF"},{"visibility":"on"}]}],
        });
        this.initMarkers(retailers);
    }

    initMarkers(retailers) {
        // Reset markers
        const self = this;
        this.markers.length = 0;
        this.infowindow.close();
        var container = $('#results-retailers').parent();

        // Set Pin Icon
        this.pin = {
            url:        `${this.dir}/../dist/images/dev/pin-location.svg`,
            size:       new window.google.maps.Size(34, 40),
            origin:     new window.google.maps.Point(0, 0),
            scaledSize: new window.google.maps.Size(34, 40),
        }

        // Set Markers & Click Event
        for (let i = 0; i < retailers.length; i++) {
            let marker = new window.google.maps.Marker({
                id:         retailers[i].id,
                position:   new window.google.maps.LatLng(retailers[i].lat, retailers[i].lng),
                lat:        retailers[i].lat,
                lng:        retailers[i].lng,
                title:      retailers[i].title,
                address:    retailers[i].address,
                postal:     retailers[i].postal,
                city:       retailers[i].city,
                phone:      retailers[i].phone,
                direction:  retailers[i].direction,
                seemore:    retailers[i].seemore,
                label1:     retailers[i].label1,
                label2:     retailers[i].label2,
                public:     retailers[i].public,
                clickable:  true,
                icon:       this.pin,
                map:        this.map,
            });

            marker.addListener('click', () => {
                this.markers.forEach(single_marker => {
                    single_marker.setIcon(`${this.dir}/../dist/images/dev/pin-location.svg`);
                });    
                marker.setIcon(`${this.dir}/../dist/images/dev/pin-location-hover.svg`);

                this.infowindow.setContent(this.infoContent(marker));
                this.infowindow.open(this.map, marker);

                $('.retailer-item').removeClass('selected');
                if($('#retailer-'+marker.id).length) {
                    var element =  $('#retailer-'+marker.id);
                    element.addClass('selected');
                    var position = element.offset().top - container.offset().top + container.scrollTop();
                    container.animate({
                        scrollTop: position
                    });
                }
            });

            this.infowindow.addListener('closeclick', () => {
                $('.retailer-item').removeClass('selected');
                marker.setIcon(`${this.dir}/../dist/images/dev/pin-location.svg`);  
            });
          
            this.markers.push(marker);
        }

        this.mapBounds(retailers);

        // Display all results by default
        for (let i = 0; i < retailers.length; i++) {
            // this.resultscontainer.innerHTML += this.resultContent(retailers[i]);

            $('#results-retailers').on('click', '#retailer-'+retailers[i].id, () => { 
                var el = $('#retailer-'+retailers[i].id);
                $('.retailer-item').removeClass('selected');
                el.addClass('selected');

                var markerselected = el.data('marker');
                var marker_el = $.grep(this.markers, function(e){ return e.id == markerselected; });

                if(marker_el.length) {
                    this.infowindow.setContent(this.infoContent(marker_el[0]));
                    this.infowindow.open(this.map, marker_el[0]);
                    this.map.setZoom(12);
                    this.map.setCenter(marker_el[0].getPosition());
                }

                if(this.isMobile()) {
                    $('#filter-map .mb-dropdown').removeClass('js-toggle');
                }
            });
        }

        let clusterStyles = [{
            textColor: 'black',
            url: `${this.dir}/../dist/images/dev/cluster.svg`,
            height: 44,
            width: 44,
            anchorText: [14, 0],
            strokeWeight: 3,
            textSize: 14,
        }];

        let mcOptions = {
            gridSize: 37,
            styles: clusterStyles,
            maxZoom: 15
        };

        this.clusters = new window.MarkerClusterer(this.map, this.markers, mcOptions);

        window.google.maps.event.addListener(self.map, 'idle', function() {
            self.clusters.setMap(self.map);
        });
    }

    // DOM Structure Marker Tooltip
    infoContent(marker) {
        let html = '';
        html += '<div class="retailer-tooltip" data-retailer="'+marker.id+'">';
            html += '<div class="retailer-inner">';
                html += '<div class="retailer-inner-top">';
                    html += '<div class="retailer-title">'+marker.title+'</div>';
                    html += '<div class="retailer-address">'+marker.address+'</div>';
                html += '</div>';
                html += '<div class="retailer-inner-bottom">';
                    html += '<a href="tel:'+marker.phone+'" class="retailer-phone">'+marker.phone+'</a>';
                    html += '<a href="'+marker.direction+'" target="_blank" class="retailer-direction">'+marker.label1+'</a>';
                html += '</div>';
            html += '</div>';
        html += '</div>';

        return html;
    }

    // DOM Structure Results
    resultContent(retailer) {
        let html = '';
        html += '<div id="retailer-'+retailer.id+'" class="retailer-item" data-marker="'+retailer.id+'">';
            html += '<div class="retailer-inner">';
                html += '<div class="retailer-inner-top">';
                    html += '<div class="retailer-title">'+retailer.title+'</div>';
                    html += '<div class="retailer-address">'+retailer.address+'</div>';
            //     html += '<div class="distance">';
            //         html += '<div class="ville">'+retailer.city+'</div>';
            //         html += '<div class="km">('+retailer.distance+' km)</div>';
            //     html += '</div>';
                html += '</div>';
                html += '<div class="retailer-inner-bottom">';
                    html += '<a href="tel:'+retailer.phone+'" class="retailer-phone">'+retailer.phone+'</a>';
                    html += '<a href="'+retailer.direction+'" target="_blank" class="retailer-direction">'+retailer.label1+'</a>';
                html += '</div>';
            html += '</div>';
        html += '</div>';

        return html;
    }

    // DOM Structure Filter Results
    filterContent(filter) {
        let html = '';
        html += '<div class="input-row">';
            html += '<input class="check-filter" type="checkbox" data-term="'+filter.term_id+'" name="'+filter.slug+'">';
            html += '<label for="'+filter.slug+'">'+filter.name+'</label>';
        html += '</div>';

        return html;
    }

    // All markers must be in map
    mapBounds(retailers) {
        this.bounds = new window.google.maps.LatLngBounds();
        for (let i = 0; i < retailers.length; i++) {
            let pos = { lat: retailers[i].lat, lng: retailers[i].lng };
            this.bounds.extend(pos);
        }
        this.map.fitBounds(this.bounds);
    }

    // Get data from form
    getZipCode(e) {
        e.preventDefault();
        // if (this.checkPattern()) {
            this.inputerror.classList.remove('js-error');
            let data = this.$cache.form.serializeArray();
            this.getLocationData(data[0].value, data[1].value);
        // } else {
        //     this.inputerror.classList.add('js-error');
        // }
    }

    // Get Lat & Lng from Zip Code
    getLocationData(zipcode, radius) {
        const self = this;
        let geocoder = new window.google.maps.Geocoder();
        if (zipcode) {
            geocoder.geocode( { "address": zipcode }, function(results, status) {
                if (status == window.google.maps.GeocoderStatus.OK && results.length > 0) {
                    let location = results[0].geometry.location;
                    self.findClosestretailer(location, radius);
                }
            });
        } else {
            this.reset();
        }
    }

    // Match data with filters
    filterMarkers(closest) {
        if (closest.length > 0) {
            const filters = closest.filter(el => {
                return el.filters.find(element => {
                    return closest.some(i => element.slug.includes(i));
                });
            });

            return filters;
        }
    }

    // Get distance
    findClosestretailer(origin, radius) {
        let termsArr     = [];
        let concatArr    = [];
        const seen       = new Set();
        this.closest.length = 0;
        this.resultscontainer.innerHTML  = '';

        for (let i = 0; i < this.markers.length; i++) {
            let distance = window.google.maps.geometry.spherical.computeDistanceBetween(this.markers[i].getPosition(), origin);
            let distanceKM = parseInt((distance / 1000).toFixed(2));
            this.markers[i].distance = distanceKM;
            if (radius != 0 && distanceKM <= radius) {
                this.closest.push(this.markers[i]);
                this.markers[i].setMap(this.map);
            } else if (radius == 0) {
                this.closest.push(this.markers[i]);
                this.markers[i].setMap(this.map);
            } else {
                this.markers[i].setMap(null);
            }
        }

        if (this.closest.length) {
            this.mapBounds(this.closest);
        } else{
            this.mapBounds(this.retailers);
        }
       
        this.closest.sort(this.sortByDist);

        if (this.closest.length == 1) {
            this.map.setZoom(14);
        }

        for (let i = 0; i < this.closest.length; i++) {
            this.resultscontainer.innerHTML += this.resultContent(this.closest[i]);
            termsArr.push(this.closest[i].filters);
        }

        if(this.isMobile()) {
            $('#filter-map .mb-dropdown').addClass('js-toggle');
        }

        // Remove duplicates from object
        const filteredArr = concatArr.filter(el => {
            const duplicate = seen.has(el.term_id);
            seen.add(el.term_id);
            return !duplicate;
        });

    }

    // Sort by distance
    sortByDist(a,b) {
        return (a.distance - b.distance)
    }

    // Remove duplicates from array
    removeDuplicates(array) {
        let uniqueNames = [];
        $.each(array, function(i, el){
            if($.inArray(el, uniqueNames) === -1) uniqueNames.push(el);
        });

        return uniqueNames;
    }

    // Mobile dropdowns
    dropdownMobile(e) {
        e.preventDefault();
        if (!e.target.classList.contains('js-toggle')) {
            e.target.classList.add('js-toggle');
        } else {
            e.target.classList.remove('js-toggle');
        }
    }

    // Check zipcode pattern
    checkPattern() {
        let re_cacp = /^[\d{5}(?:-\d{4})?|[a-zA-Z]\d[a-zA-Z] ?\d[a-zA-Z]\d+$/; // Canadian Postal Code
        let re_uszip = /(^\d{5}$)|(^\d{5}-\d{4}$)/; // USA Postal Code

        return re_cacp.test(this.inputlocal.value) || re_uszip.test(this.inputlocal.value);
    }

    reset(e) {
        e.preventDefault();
        this.resultscontainer.innerHTML = '<p>Search a zip code or a city</p>';
        this.inputerror.classList.remove('js-error');
        this.checks.length = 0;
        this.infowindow.close();
        document.getElementById('filter-map').reset();
        this.initMarkers(this.retailers);
    }

    isMobile() {
        return $(window).width() < 991;
    }
}

export default FilterGoogleMap;


// WEBPACK FOOTER //
// ./scripts/components/filter-google-map.js